import { THealthDomainWithOverall } from '@/types/Health.types';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import useTelemetry from '@/providers/TelemetryProvider/useTelemetry';
import { mixpanelEvents } from '@/constants/mixpanel';
import { editGoalPatch } from '@/services/api/requests/growthZone';
import queryKeys from '@/constants/queryKeys';

const useEditGoal = (domain: THealthDomainWithOverall, onSuccessCallback?: () => void) => {
  const toast = useToast();
  const { trackEvent } = useTelemetry();

  const { isPending, isSuccess, mutate } = useMutation<void, Error, { goalId: string; editedDomainGoalText: string }>(
    {
      mutationKey: [queryKeys.growthZone.editGoal],
      mutationFn: async ({ goalId, editedDomainGoalText }) => {
        await editGoalPatch(goalId, editedDomainGoalText);
      },
      onSuccess: () => {
        onSuccessCallback?.();

        trackEvent(mixpanelEvents.GOAL_EDITED, { domain });
      },
      onError: (error) => {
        toast({
          title: 'Error editing a goal',
          description: error instanceof Error ? error.message : 'An unexpected error occurred.',
          status: 'error'
        });
      },
    },
  );

  return {
    isPending,
    mutate,
    isSuccess,
  };
};

export default useEditGoal;
